document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.tabs ul li');
    const sections = document.querySelectorAll('.tabs .tab-section');

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        tabs.forEach(t => t.classList.remove('active'));
        sections.forEach(s => s.classList.remove('active'));

        tab.classList.add('active');
        document.querySelector(`#tab-${tab.getAttribute('data-tab-id')}`).classList.add('active');
      });
    });

    // Set the first tab as active by default
    tabs[0]?.classList.add('active');
    sections[0]?.classList.add('active');
  });